function setCookiePreferences(preferences) {
  const cookieValue = encodeURIComponent(JSON.stringify(preferences));
  const secureFlag = window.location.protocol === "https:" ? "; secure" : "";
  document.cookie = `cookie_preferences=${cookieValue}; path=/; max-age=31536000${secureFlag}; SameSite=Lax`;
  window.location.reload();
}

function openCookieModal(modal) {
  if (!modal) return;
  modal.style.display = "block";
  modal.removeAttribute("aria-hidden");
  modal.setAttribute("aria-modal", "true");
  modal.classList.add("show");
  document.body.classList.add("modal-open");
}

function closeCookieModal(modal) {
  if (!modal) return;
  modal.classList.remove("show");
  modal.setAttribute("aria-hidden", "true");
  modal.removeAttribute("aria-modal");
  modal.style.display = "none";
  document.body.classList.remove("modal-open");
}

function initializeLandingCookieConsent() {
  const modal = document.getElementById("cookieConsentModal");
  const rejectAllBtn = document.getElementById("rejectAllCookies");
  const acceptSelectedBtn = document.getElementById("acceptSelectedCookies");
  const cookieAllowDirect = document.getElementById("cookieAllowDirect");
  const cookieRejectDirect = document.getElementById("cookieRejectDirect");
  const manageButton = document.querySelector('[data-bs-target="#cookieConsentModal"]');
  const closeButton = modal ? modal.querySelector(".btn-close") : null;

  if (manageButton && manageButton.dataset.landingCookieBound !== "true") {
    manageButton.dataset.landingCookieBound = "true";
    manageButton.addEventListener("click", (event) => {
      event.preventDefault();
      openCookieModal(modal);
    });
  }

  if (closeButton && closeButton.dataset.landingCookieBound !== "true") {
    closeButton.dataset.landingCookieBound = "true";
    closeButton.addEventListener("click", () => closeCookieModal(modal));
  }

  if (rejectAllBtn && rejectAllBtn.dataset.landingCookieBound !== "true") {
    rejectAllBtn.dataset.landingCookieBound = "true";
    rejectAllBtn.addEventListener("click", () => setCookiePreferences({ analytics: false }));
  }

  if (acceptSelectedBtn && acceptSelectedBtn.dataset.landingCookieBound !== "true") {
    acceptSelectedBtn.dataset.landingCookieBound = "true";
    acceptSelectedBtn.addEventListener("click", () => {
      const analyticsInput = document.getElementById("analyticsCookies");
      setCookiePreferences({ analytics: Boolean(analyticsInput && analyticsInput.checked) });
    });
  }

  if (cookieAllowDirect && cookieAllowDirect.dataset.landingCookieBound !== "true") {
    cookieAllowDirect.dataset.landingCookieBound = "true";
    cookieAllowDirect.addEventListener("click", () => setCookiePreferences({ analytics: true }));
  }

  if (cookieRejectDirect && cookieRejectDirect.dataset.landingCookieBound !== "true") {
    cookieRejectDirect.dataset.landingCookieBound = "true";
    cookieRejectDirect.addEventListener("click", () => setCookiePreferences({ analytics: false }));
  }
}

function initializeScrollReveal() {
  const landing = document.querySelector(".acvire-landing");
  const motionElements = landing ? Array.from(landing.querySelectorAll(".acvire-motion")) : [];

  if (!landing || motionElements.length === 0) return;

  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduceMotion || !("IntersectionObserver" in window)) {
    motionElements.forEach((element) => element.classList.add("is-visible"));
    return;
  }

  landing.classList.add("acvire-reveal-ready");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: "0px 0px -8% 0px",
    threshold: 0.12
  });

  motionElements.forEach((element) => observer.observe(element));
}

function initializeParallax() {
  const hasLanding = document.querySelector(".acvire-landing");
  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!hasLanding || reduceMotion) return;

  let ticking = false;

  const update = () => {
    const scrollY = Math.min(window.scrollY || window.pageYOffset || 0, 1800);
    document.documentElement.style.setProperty("--acvire-parallax-y", `${Math.round(scrollY)}px`);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener("scroll", requestUpdate, { passive: true });
}

function initializeMegaNavigation() {
  const dropdowns = Array.from(document.querySelectorAll(".acvire-nav__dropdown"));

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("toggle", () => {
      if (!dropdown.open) return;

      dropdowns.forEach((otherDropdown) => {
        if (otherDropdown !== dropdown) otherDropdown.removeAttribute("open");
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeLandingCookieConsent();
  initializeMegaNavigation();
  initializeScrollReveal();
  initializeParallax();
});
